<template>
  <div class="search-field-container">
    <div class="uk-inline">
      <a class="uk-form-icon uk-form-icon-flip" href="#" @click.prevent="onSearch" uk-icon="icon: search"></a>
      <input class="uk-input" type="text" v-model="q" @keyup="onKeyUp($event)" :style="{ width: width }" />
    </div>
    <div class="count" v-if="count">{{ count }}件</div>
  </div>
</template>
<style lang="scss" scoped>
.search-field-container {
  display: flex;
  align-items: center;
  min-width: 250px;
}
.count {
  margin-left: $spacing-small;
}
</style>
<script lang="ts">
import { Vue } from "vue-class-component";
import { Prop, Emit } from "vue-property-decorator";
import Fuse from "fuse.js";
export default class SearchField extends Vue {
  target: [] = [];
  q = "";
  @Prop({ type: Number }) count: number | null = null;
  @Prop({ type: String }) width: string | null = null;
  @Prop({ type: Array, required: true }) tableData: object[] = [];
  @Prop({ type: Array }) filterColumns: string[] = ["name"];
  onKeyUp(event: KeyboardEvent) {
    if (["Enter", "NumpadEnter"].includes(event.code)) {
      event.preventDefault();
      this.onSearch();
    }
  }
  created() {
    this.target = Object.create(this.tableData);
  }
  @Emit("search")
  onSearch() {
    const pattern = this.q.trim();
    if (this.target && pattern.length) {
      const options = {
        isCaseSensitive: false,
        includeScore: true,
        shouldSort: false,
        includeMatches: true,
        findAllMatches: true,
        threshold: 0.3,
        maxPatternLength: 8,
        limit: 300,
        keys: this.filterColumns
      };
      const fuse = new Fuse(this.target, options);
      const tableResult: [] = [];
      const fuesResult = fuse.search(pattern).map(c => ({
        index: c.refIndex,
        matches: c.matches,
        score: c.score
      }));
      fuesResult.forEach(el => {
        tableResult.push(this.target[el.index]);
      });
      return tableResult;
    }
    return null;
  }
}
</script>
